import { Banner } from "@jasper/shared";
import { useOrderDesignReview } from "@jasper/use-cases";

interface Props {
  orderId: string;
}

export const OrderDesignBanner = ({ orderId }: Props) => {
  const { openedOrderDesign, remainingTimeToReview, isLoading, error } =
    useOrderDesignReview({ orderId });

  if (
    isLoading ||
    error ||
    !openedOrderDesign ||
    !remainingTimeToReview ||
    remainingTimeToReview < 0
  ) {
    return null;
  }

  const lastDayToReview =
    remainingTimeToReview && remainingTimeToReview <= 24 * 60 * 60 * 1000;
  const remainingTimeSentence = lastDayToReview
    ? `Il ne vous reste plus qu'aujourd'hui pour valider la conception de votre prothèse.`
    : `Il vous reste ${Math.ceil(remainingTimeToReview! / (24 * 60 * 60 * 1000))} jours pour la valider.`;

  return (
    <Banner
      intent="warning"
      content={`Vous avez une conception de prothèse en cours de validation. ${remainingTimeSentence}`}
    />
  );
};
